import {
    BTN_ACTIVE,
    CARD_RECTO_CLASSNAME,
    CARD_RECTO_HIDDEN,
    CARD_VERSO_CLASSNAME,
    CARD_VERSO_VISIBLE,
    FILTER_ITEM_PULL_UP,
    HIDDEN,
    ITEM_FILTER_CLASSNAME
} from './constants';

export default class Filter {
    constructor(domElement) {
        if(!domElement) {
            throw new Error('domElement is undefined');
        }

        if(domElement.dataset.filterInitialized === 'true') {
            throw new Error('Module already initialized');
        }

        domElement.dataset.filterInitialized = 'true';

        this.domElement = domElement;

        this.setElements();

        this.updateCounters();
        this.initListeners();
        this.refreshBandeauPosition();
    }

    setElements() {
        this.filter = 'all';
        this.domSelect = this.domElement.querySelector('[data-filter-select]');
        this.domButtonsList = [...this.domElement.querySelectorAll('[data-filter-category]')];
        this.domItemsList = [...this.domElement.querySelectorAll('[data-filter-item-category]')];
        this.domBandeaux = [...this.domElement.querySelectorAll('[data-filter-category-bandeau]')];
    }

    initListeners() {
        this.domButtonsList.forEach(domButton => domButton.addEventListener('click', this.handleButtonClick.bind(this)));
        this.domSelect && this.domSelect.addEventListener('change', this.handleSelectChange.bind(this));
        this.domItemsList.forEach((domCard, index) => {
            const domOpenVerso = domCard.querySelector('[data-open-verso]');
            domOpenVerso && domOpenVerso.addEventListener('click', this.handleOpenVerso.bind(this, index));
        });
    }

    handleOpenVerso(index) {
        this.closeOtherCards(index);
    }

    handleButtonClick(evt) {
        const target = evt.currentTarget || evt.target;
        this.setFilter(target.dataset.filterCategory, true);
    }

    handleSelectChange(evt) {
        const {target} = evt;
        this.setFilter(target.value);
    }

    setFilter(category, refreshSelect = false) {
        this.filter = category;
        this.refreshItems();
        this.refreshButtons();
        this.refreshBandeaux();
        this.refreshBandeauPosition();
        refreshSelect && this.refreshSelect();
    }

    closeOtherCards(indexCurrentOpenedCard) {
        const domCardList = this.domItemsList.filter((domItem, index) => indexCurrentOpenedCard !== index);

        domCardList.forEach(domCard => {
            const domCardRecto = domCard.querySelector(`.${CARD_RECTO_CLASSNAME}`);
            const domCardVerso = domCard.querySelector(`.${CARD_VERSO_CLASSNAME}`);

            domCardRecto && domCardRecto.classList.remove(CARD_RECTO_HIDDEN);
            domCardVerso && domCardVerso.classList.remove(CARD_VERSO_VISIBLE);
        });
    }

    refreshItems() {
        this.domItemsList.forEach(domItem => {
            const hasContainer = domItem.closest(`.${ITEM_FILTER_CLASSNAME}`);
            if(hasContainer) {
                hasContainer.classList.toggle(HIDDEN, this.filter !== 'all' && this.filter !== domItem.dataset.filterItemCategory);
            } else {
                domItem.classList.toggle(HIDDEN, this.filter !== 'all' && this.filter !== domItem.dataset.filterItemCategory);
            }
        });
    }

    refreshBandeauPosition() {
        this.domItemsList.forEach(item => {
            const hasContainer = item.closest(`.${ITEM_FILTER_CLASSNAME}`);
            if(hasContainer) {
                hasContainer.classList.remove(FILTER_ITEM_PULL_UP);
            } else {
                item.classList.remove(FILTER_ITEM_PULL_UP);
            }
        });

        this.domItemsList.filter(item => (this.filter === 'all' ? true : item.dataset.filterItemCategory === this.filter)).forEach((item, idx) => {
            const hasContainer = item.closest(`.${ITEM_FILTER_CLASSNAME}`);
            if(hasContainer) {
                hasContainer.classList.toggle(FILTER_ITEM_PULL_UP, idx < 6);
            } else {
                item.classList.toggle(FILTER_ITEM_PULL_UP, idx < 6);
            }
        });
    }

    refreshBandeaux() {
        this.domBandeaux.forEach(bandeau => bandeau.classList.toggle(HIDDEN, this.filter !== bandeau.dataset.filterCategoryBandeau));
    }

    refreshButtons() {
        this.domButtonsList.forEach(button => button.classList.toggle(BTN_ACTIVE, this.filter === button.dataset.filterCategory));
    }

    refreshSelect() {
        const item = this.domSelect.querySelector(`[value="${this.filter}"]`);
        if(item) {
            this.domSelect.selectedIndex = [...this.domSelect.children].indexOf(item);
        }
    }

    updateCounters() {
        this.domButtonsList.forEach(domButton => {
            domButton.querySelector('[data-filter-category-count]').textContent = domButton.dataset.filterCategory === 'all'
                ? `(${this.domItemsList.length})`
                : `(${this.domItemsList.filter(item => item.dataset.filterItemCategory === domButton.dataset.filterCategory).length})`;
        });

        [...this.domSelect.children].forEach(option => {
            const optionText = option.innerHTML;
            option.innerHTML = option.value === 'all'
                ? `${optionText} (${this.domItemsList.length})`
                : `${optionText} (${this.domItemsList.filter(item => item.dataset.filterItemCategory === option.value).length})`;
        });
    }
}
